import React, { memo, useReducer, useMemo } from 'react';
import { Form } from '@redlink/components/organisms';
import { withPopUp } from '@redlink/components/atoms';
import { FormSection, SelectableLinks } from '@redlink/components/molecules';
import { DataEntryModalTemplate } from '@redlink/components/templates';
import { useLocale } from '@redlink/assets/locale';
import {
  useQuery,
  useMutation,
  getPageLinksQuery,
  editResumeLinks,
} from '@redlink/services';
import { initialState, reducer, types } from './store';
import { freshCache } from './cache';

export const ResumeLinksEditPage = withPopUp(
  memo(({ currentLinks, onDismiss, pageName, onChange }) => {
    const { dictionary } = useLocale();

    const currentLinksIds = useMemo(
      () => currentLinks.map((item) => item.id),
      [currentLinks]
    );

    const [{ selectedLinks }, dispatch] = useReducer(
      reducer,
      initialState(currentLinksIds)
    );

    const {
      loading: getPageLinksIsBusy,
      data: { Links },
    } = useQuery(getPageLinksQuery);

    const [submitEditResumeLinks, { loading: submitResumeLinksIsLoading }] =
      useMutation(editResumeLinks, {
        done: () => onDismiss(),
        update: freshCache({ pageName }),
      });

    return (
      <DataEntryModalTemplate>
        <Form
          isBusy={submitResumeLinksIsLoading || getPageLinksIsBusy}
          actions={[
            {
              title: dictionary.cancel,
              variant: 'secondary',
              onPress: onDismiss,
            },
            {
              title: dictionary.add,
              variant: 'primary',
              onPress: () =>
                onChange
                  ? onChange({ selectedLinksIds: selectedLinks, Links })
                  : submitEditResumeLinks({
                      items: selectedLinks,
                    }),
            },
          ]}
        >
          <FormSection title={dictionary.socialMedia}>
            <SelectableLinks
              links={Links}
              {...{ selectedLinks }}
              onSelectItem={(item) =>
                dispatch({
                  type: types.SET_SELECTED_LINKS,
                  payload: item.id,
                })
              }
            />
          </FormSection>
        </Form>
      </DataEntryModalTemplate>
    );
  })
);
